<template lang="pug">
.color-picker-field-widget
  div
    //- filter-field-widget(:field="filter", v-on:change-color-filter-values="filterUpdated")
    div(v-for="range in getRanges()")
      .range-color-header-parts
        span.range-color-header-part.title(v-text="range.label")
        span.range-color-header-part.color-summary(v-if="isThisRange(selectedColor, range.key)" v-html="getSummary()")
      div
        label.round-color-input(:title="color.label" v-for="color, colorKey in colorByRangekey(colorAFormated, range.key)" v-if="isVisible(colorKey, colorAFormated)" :for="`colorA_${colorKey}`")
          //- img(:src="color.imageZoomUrl")
          input(type="radio", :name="`colorA`", :id="`colorA_${colorKey}`", :disabled="color.outOfStock", :value="colorKey", v-model="colorASelected")
          .img(:class="{'selected': (colorASelected === colorKey && !color.outOfStock)}" v-bind:style="{ 'background': colorPictureStyleBackground(color.imageZoomUrl, color.outOfStock)}")
            .check-mark(v-if="(colorASelected === colorKey && !color.outOfStock)")
    
</template>
<script>
import fr from '../../../../config/translationFr'
export default {
  name: 'vr-color-picker-field-widget',
  props: {

    colorisA: {
      type: Object,
      default: {}
    },
    cc: {
      type: Object,
      default: () => ({
        config_1: {
          prefilled_values: {
            'CH-458_matire': 'OPT-1184_aluminium'
          }
        }
      })
    },
    validation: {
      type: Object,
      default: {}
    },
    uom: {
      type: String,
      default: 'cm'
    },
    fieldHasChanged: {
      type: Function,
      default: function () {}
    },
    mint: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      colorASelected: null,
      oneColorType: '',
      selectedColor: '',
      colorASelectedSummary: {
        range: '',
        label: '',
        key: ''
      }
    }
  },
  created: function () {
    this.colorASelected = this.cc.config_1.prefilled_values['CH-461_coloris']
  },
  updated: function () {
    this.colorASelected = this.cc.config_1.prefilled_values['CH-461_coloris']
  },
  components: {
  },
  computed: {
    frText: function () {
      return fr
    },
    colorAFormated: function () {
      return this.colorisA
    },
    isOneColorType: function () { return this.cc.config_1.prefilled_values['CH-461_coloris'] === this.oneColorType }
  },
  methods: {
    isThisRange: function (colorKey, rangeKey) {
      return colorKey.includes(rangeKey)
    },
    colorPictureStyleBackground: function (url, outOfStock = false) {
      const imgOutOfStock = outOfStock ? "url('https://cdn.configurateur.stores-discount.com/matiere/rupture-neutre.png') no-repeat -1px," : ''
      return `${imgOutOfStock} url(${url}) no-repeat -3px -3px`
    },
    colorByRangekey: function (colorFormated, rangeKey) {
      return Object.keys(colorFormated.values).reduce((reduced, colorKey) => {
        const color = colorFormated.values[colorKey]
        if (colorKey.includes(rangeKey)) {
          // To check color.range or colorKey
          const hidenValues = (colorFormated.validation || {}).hidden_values || []
          if (!hidenValues.find(hiddenRangeKey => hiddenRangeKey === colorKey)) {
            if (this.isVisible(colorKey, colorFormated)) {
              reduced[colorKey] = color
            }
          }
        }
        return reduced
      }, {})
    },
    sortObj: function (obj) {
      return Object.fromEntries(
        Object.entries(obj).sort(([ , a ], [ , b ]) => a.weight - b.weight)
      )
    },
    filterUpdated: function (chOpt) {
      this.$emit('field-changed', chOpt)
    },
    isVisible: function (colorKey, colorFormated) {
      const hidenValues = (colorFormated.validation || {}).hidden_values || []
      return !hidenValues.find(code => code === colorKey)
    },
    rangeIsNotEmpty: function (color, range) {
      return Object.keys(this.colorByRangekey(color, range)).length > 0
    },
    getRanges: function () {
      const hiddenValues = this.validation.hidden_values || []
      const ranges = [
        {
          label: 'Aluminium',
          key: 'alu'
        }
      ]
      if (hiddenValues.includes('CH-461_coloris_MAT-510_vr-pvc-blanc') && hiddenValues.includes('CH-461_coloris_MAT-1560_vr-pvc-beige')) {
        return ranges
      } else {
        ranges.push({
          label: 'PVC',
          key: 'pvc'
        })
      }
      return ranges
    },
    getSummary: function () {
      const ral = this.colorASelectedSummary.ral !== 'N/A' ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;RAL ' + this.colorASelectedSummary.ral : ''
      return this.colorASelectedSummary.label + ' ' + ral
    }
  },
  watch: {
    cc: function (newValue, oldValue) {
    },
    colorASelected: function (newValue, oldValue) {
      this.colorASelectedSummary = this.colorisA.values[newValue]
      this.selectedColor = newValue
      const materialValue = (newValue === 'CH-461_coloris_MAT-510_vr-pvc-blanc' || newValue === 'CH-461_coloris_MAT-1560_vr-pvc-beige') ? 'OPT-1185_pvc' : 'OPT-1184_aluminium'
      this.$emit('field-changed', {
        [this.colorisA.chKey]: { newValue: newValue }
      })
      // Ab test field dependence
      this.$emit('field-changed', {
        'CH-458_matire': { newValue: materialValue }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// VrColorPickerFieldWidget.vue?7403ce3c